// extracted by mini-css-extract-plugin
export default {"pagination-container":"zVjbZW","paginationContainer":"zVjbZW"};